<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">فرم ثبت اطلاعات متن نامه</h5>
      <form [formGroup]="AddNewTextletter" (submit)="SubmitAddNewTextletter()">

        <input type="hidden" formControlName="id" />

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1"> موضوع نامه</label>
            <select class="custom-select" formControlName="Subject_id" >
              <option value="0">انتخاب کنید</option>
              <option *ngFor="let item of DataList_SubjectLetter" [value]="item.id">{{item.title}}</option>
            </select>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">متن</label>
            <input formControlName="Dsc" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Dsc().valid && get_Form_Dsc().touched" class="form-text text-muted MyErrorRedColor">متن را وارد نمائید.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">سمت امضاء کننده</label>
            <input formControlName="Semat" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Semat().valid && get_Form_Semat().touched" class="form-text text-muted MyErrorRedColor">سمت امضاء کننده را وارد نمائید.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نام امضاء کننده</label>
            <input formControlName="Name" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Name().valid && get_Form_Name().touched" class="form-text text-muted MyErrorRedColor">نام امضاء کننده را وارد نمائید.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">کد سریالی</label>
            <input formControlName="Code" type="text" class="form-control"  placeholder="اینجا تایپ کنید ...">
            <small *ngIf="!get_Form_Code().valid && get_Form_Code().touched" class="form-text text-muted MyErrorRedColor">کد سریالی را وارد نمائید.</small>
          </div>
        </div>
          <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
          <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewTextletter.valid" class="btn btn-success" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
          <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i class="fa fa-times-rectangle" ></i> لغو </button>
          <button routerLink="/Textletter" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت </button>
      </form>
  </div>
</div>

